import React from 'react';
export var CrossIcon = function CrossIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    fill: "currentColor",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    clipRule: "evenodd",
    viewBox: "0 0 10 10"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "6 5 10 9 9 10 5 6 1 10 0 9 4 5 0 1 1 0 5 4 9 0 10 1"
  }));
};